import { InlineMarkdown } from './InlineMarkdown';

/** Surface the caption sits on. `inverse` is a photograph or a dark backdrop. */
export type CaptionTone = 'default' | 'inverse';

interface CaptionMarkdownProps {
  caption: string;
  tone?: CaptionTone;
}

/**
 * A photo caption with its inline markdown rendered.
 *
 * The same small markdown every block field understands (`parseInline.ts`),
 * with the quieter link styling a credit line wants. Renders inline only: the
 * caller owns the `<figcaption>` and its type styling, because a hero credit, a
 * gallery thumbnail and a lightbox each want a different size and alignment.
 */
export function CaptionMarkdown({ caption, tone = 'default' }: CaptionMarkdownProps) {
  return <InlineMarkdown text={caption} tone={tone === 'inverse' ? 'inverse' : 'caption'} />;
}
